import { BaseService } from './BaseServices';
import { IViewTypes } from '../types/ProfileTypes';
import authService from './AuthServices';
import { AxiosPromise } from 'axios';

export class ProfileService extends BaseService {
  constructor() {
    super('profile');
  }

  getActiveProfile = (typeProfile: IViewTypes, user_id: string | number) => {
    const params = {
      user_id,
      profileType: typeProfile
    };

    return this.httpAxios
      .get('/active', { params })
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };

  setActiveProfile = (typeProfile: IViewTypes, profileId: string | number) => {
    const body = {
      profileType: typeProfile,
      user_id: authService.getUser().id,
      profile_id: profileId
    };

    return this.httpAxios
      .post('/active', body)
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };

  public update(item: any): AxiosPromise<any> {
    return this.httpAxios
      .put('', item)
      .then(response => response)
      .catch(err => {
        throw err;
      });
  }
}
const profileService = new ProfileService();

export default profileService;
